var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Notifications',{attrs:{"unseenCount":_vm.unseenCount,"notifications":_vm.notifications,"icon":_vm.icon,"label":"navigation.notifications.notifications"},on:{"open":_vm.open}})
}
var staticRenderFns = []

export { render, staticRenderFns }